import { TIPO_ORDER, TIPO_META } from "@/lib/agendaTipi";

// Colored type selector shown as the first field in appointment/request forms.
// 5 buttons on desktop (1 row), 2 rows on mobile (3 + 2). Mandatory: shows red error when empty.
export function TipoPicker({ value, onChange, error, includeBlocked = true, testid = "tipo-picker" }) {
  const keys = includeBlocked ? TIPO_ORDER : TIPO_ORDER.filter((k) => k !== "bloccato");
  return (
    <div data-field-error={error ? "true" : undefined} data-testid={testid}>
      <label className="block text-[11px] font-semibold uppercase tracking-wide text-[var(--muted)] mb-1.5">
        Tipo <span className="text-red-500">*</span>
      </label>
      <div className="flex flex-wrap gap-2">
        {keys.map((k) => {
          const sel = value === k;
          const color = TIPO_META[k].color;
          return (
            <button
              key={k}
              type="button"
              data-testid={`tipo-opt-${k}`}
              aria-pressed={sel}
              onClick={() => onChange(k)}
              className={`flex grow items-center justify-center gap-1.5 px-3 py-2.5 rounded-xl border-2 text-xs sm:text-sm font-semibold min-h-[44px] whitespace-nowrap transition-colors ${sel ? "font-bold" : "border-[var(--border)] text-slate-500 hover:bg-slate-50"}`}
              style={sel ? { borderColor: color, background: `${color}1A`, color: "#111827" } : undefined}
            >
              <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ background: color }} />
              {TIPO_META[k].label}
            </button>
          );
        })}
      </div>
      {error && <p className="text-xs text-red-500 mt-1.5" data-testid={`${testid}-error`}>{error}</p>}
    </div>
  );
}

// Compact always-visible legend (colored dots + names) shown above the agenda grid.
export function TipoLegend({ withScadenza = true, className = "" }) {
  return (
    <div className={`flex flex-wrap items-center gap-x-4 gap-y-1.5 text-[11px] text-[var(--muted)] ${className}`} data-testid="agenda-legend">
      {TIPO_ORDER.map((k) => (
        <span key={k} className="inline-flex items-center gap-1.5">
          <span className="w-2.5 h-2.5 rounded-full" style={{ background: TIPO_META[k].color }} />
          {TIPO_META[k].label}
        </span>
      ))}
      {withScadenza && (
        <span className="inline-flex items-center gap-1.5">
          <span className="w-2.5 h-2.5 rounded-full" style={{ background: "#9CA3AF" }} />
          Scadenza proposta
        </span>
      )}
    </div>
  );
}
